import classNames from 'classnames';
import { useEffect, useMemo, useRef, useState } from 'react';
import { isNone } from '../_util/defineType';
import { pickDomAttrs } from '../_util/utils';
import Elevation from '../elevation';
import Tabs from './tabs';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ScrollTabs = props => {
  const {
    tabs,
    headerBackground = 3,
    extra,
    className,
    style,
    prefixClass = 'zen-design',
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-scroll-tabs");
  const attrs = pickDomAttrs(restProps);
  const availableTabs = useMemo(() => {
    return tabs.filter(it => !it.hidden);
  }, [tabs]);
  const sectionsRef = useRef({});
  const [activeTab, setActiveTab] = useState(availableTabs[0].key);
  const onClickTab = key => {
    var _sectionsRef$current;
    setActiveTab(key);
    (_sectionsRef$current = sectionsRef.current) === null || _sectionsRef$current === void 0 || (_sectionsRef$current = _sectionsRef$current[key]) === null || _sectionsRef$current === void 0 || _sectionsRef$current.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const key = entry.target.getAttribute('data-section-id');
          setActiveTab(key);
        }
      });
    }, {
      rootMargin: '-20% 0px -20% 0px',
      // 调整触发区域
      threshold: 0.5
    });

    // 观察所有模块
    Object.values(sectionsRef.current).forEach(section => {
      observer.observe(section);
    });
    return () => observer.disconnect();
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    ...attrs.data,
    className: classNames(baseClassName, className),
    style: style,
    children: [/*#__PURE__*/_jsxs(Elevation, {
      type: headerBackground,
      shadow: false,
      borderRadius: false,
      className: "".concat(baseClassName, "--header"),
      children: [/*#__PURE__*/_jsx(Tabs, {
        size: "s",
        activeKey: activeTab,
        tabs: availableTabs.map(item => ({
          ...item,
          component: null
        })),
        onChange: onClickTab,
        className: "tabs"
      }), !isNone(extra) && /*#__PURE__*/_jsx("div", {
        className: "extra",
        children: extra
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "--body"),
      children: availableTabs.flatMap((item, idx) => {
        const ele = /*#__PURE__*/_jsx("div", {
          "data-section-id": item.key,
          ref: ele => {
            if (ele) {
              sectionsRef.current[item.key] = ele;
            }
          },
          className: "scroll-section",
          children: item.component
        }, item.key);
        return idx > 0 ? [/*#__PURE__*/_jsx("div", {
          className: "scroll-divider"
        }, "".concat(item.key, "@").concat(idx)), ele] : [ele];
      })
    })]
  });
};